import InternetAndMobileShowcase from "./components/InternetAndMobileShowcase.vue";

const root = document.getElementById("internet-and-mobile-offers");

window.app = new Vue({
    el: root,
    name: 'InternetAndMobileOffers',
    components: {
        InternetAndMobileShowcase,
    },
    data: {
        pageVue: JSON.parse(root.dataset.pageVue),
        token: root.dataset.token
    }
});
